import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { MatrixKind, displayNameKeyMapping } from 'garaje/utils/permission-sets';
import type { MatrixByProduct, MatrixRow } from 'garaje/utils/permission-sets';

interface ViewProductPermissionsArgs {
  productMatrix: MatrixByProduct;
}

class ViewProductPermissionsComponent extends Component<ViewProductPermissionsArgs> {
  declare args: ViewProductPermissionsArgs;

  @tracked collapsed = false;

  get productRow(): string {
    const { productMatrix } = this.args;
    return productMatrix && productMatrix.product
      ? displayNameKeyMapping[productMatrix.product.displayNameKey] || ''
      : '';
  }

  @action
  handleCollapseAndExpand(): void {
    this.collapsed = !this.collapsed;
  }

  isRowCategory(row: MatrixRow): boolean {
    return row.kind === MatrixKind.CATEGORY;
  }

  renderRowName(row: MatrixRow): string {
    return displayNameKeyMapping[row.displayNameKey] || '';
  }
}

export default ViewProductPermissionsComponent;
